import DOMPurify from 'dompurify'

const emptyHtmlPattern =
  /^(?:\s|&nbsp;|<br\s*\/?>|<\/?(?:p|div|span|strong|em|u|ol|ul|li|blockquote|h[1-6])[^>]*>)*$/i

export const sanitizeRichTextHtml = (html: string | null | undefined): string | null => {
  if (!html) {
    return null
  }

  const sanitized = DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    ALLOWED_ATTR: ['class', 'href', 'target', 'rel'],
  }).trim()

  if (sanitized.length === 0) {
    return null
  }

  if (typeof document === 'undefined') {
    return sanitized
  }

  const container = document.createElement('div')
  container.innerHTML = sanitized

  for (const link of container.querySelectorAll<HTMLAnchorElement>('a[href]')) {
    link.setAttribute('target', '_blank')
    link.setAttribute('rel', 'noreferrer noopener')
  }

  return container.innerHTML.trim()
}

export const hasMeaningfulHtml = (html: string | null | undefined): boolean => {
  const sanitized = sanitizeRichTextHtml(html)
  if (!sanitized) {
    return false
  }

  const textContent = sanitized
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .trim()
  if (textContent.length > 0) {
    return true
  }

  return !emptyHtmlPattern.test(sanitized)
}

export const normalizeRichTextHtml = (html: string | null | undefined): string => {
  const sanitized = sanitizeRichTextHtml(html)
  return hasMeaningfulHtml(sanitized) ? (sanitized ?? '') : ''
}
